import { Employee, EmployeeService } from "../api/generated";
import { useState } from "react";

interface RegisterStepThreeProps {
  employee: Employee;
  onSaveAndContinue: () => void;
  onIssueMaterial: (employee: Employee) => void;
}

export const EmployeeRegisterStepThree = ({
  employee,
  onSaveAndContinue,
  onIssueMaterial,
}: RegisterStepThreeProps) => {
  const [isSaving, setIsSaving] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  const saveEmployee = async () => {
    setIsSaving(true);
    setErrorMessage(null);
    try {
      if (employee.id) {
        return await EmployeeService.putEmployee(employee.id, employee);
      }

      return await EmployeeService.postEmployee(employee);
    } catch (error) {
      setErrorMessage((error as Error).message);
      return null;
    } finally {
      setIsSaving(false);
    }
  };

  const handleSaveAndContinue = async () => {
    const savedEmployee = await saveEmployee();
    if (!savedEmployee) {
      return;
    }
    onSaveAndContinue();
  };

  const handleIssueMaterial = async () => {
    const savedEmployee = await saveEmployee();
    if (!savedEmployee) {
      return;
    }
    onIssueMaterial(savedEmployee);
  };

  return (
    <div className="mt-6 w-full max-w-xl mx-auto">
      <div className="card bg-base-200 shadow-xl mb-6">
        <div className="card-body">
          <h2 className="card-title text-lg">
            {employee.firstName} {employee.lastName}
          </h2>
          <div className="divider my-2"></div>
          <div className="space-y-2 text-sm">
            <div>
              <span className="font-semibold">Geboortedatum:</span>{" "}
              {employee.birthDate}
            </div>
            {employee.coordinator && (
              <div>
                <span className="font-semibold">Coordinator:</span>{" "}
                {employee.coordinator}
              </div>
            )}
            {employee.role && (
              <div>
                <span className="font-semibold">Rol:</span> {employee.role}
              </div>
            )}
            <div>
              <span className="font-semibold">Bandjes:</span>
              {employee.straps && employee.straps.length > 0 ? (
                <ul className="list-disc ml-6 mt-1">
                  {employee.straps.map((strap, index) => (
                    <li key={`${strap}-${index}`}>{strap}</li>
                  ))}
                </ul>
              ) : (
                <p className="mt-1 text-gray-500">Geen bandjes toegevoegd</p>
              )}
            </div>
          </div>
        </div>
      </div>

      {errorMessage && (
        <div role="alert" className="alert alert-error mb-4">
          <span>Opslaan mislukt: {errorMessage}</span>
        </div>
      )}

      <div className="flex w-full justify-end gap-2">
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleIssueMaterial}
          disabled={isSaving}
        >
          Materiaal uitgeven
        </button>
        <button
          type="button"
          className="btn btn-primary"
          onClick={handleSaveAndContinue}
          disabled={isSaving}
        >
          {isSaving ? "Opslaan..." : "Opslaan en door naar de volgende"}
        </button>
      </div>
    </div>
  );
};
